import type { ICourse } from '../courses';
import { PERSONAL_EPISODE_01_MATERIALS } from './personal-episode-01-materials';
import { PERSONAL_EPISODE_02_MATERIALS } from './personal-episode-02-materials';
import { PERSONAL_EPISODE_03_MATERIALS } from './personal-episode-03-materials';
import { PERSONAL_EPISODE_04_MATERIALS } from './personal-episode-04-materials';
import { PERSONAL_EPISODE_05_MATERIALS } from './personal-episode-05-materials';
import { PERSONAL_EPISODE_06_MATERIALS } from './personal-episode-06-materials';
import { PERSONAL_EPISODE_07_MATERIALS } from './personal-episode-07-materials';
import { PERSONAL_EPISODE_08_MATERIALS } from './personal-episode-08-materials';

const EPISODES = [
  PERSONAL_EPISODE_01_MATERIALS, PERSONAL_EPISODE_02_MATERIALS,
  PERSONAL_EPISODE_03_MATERIALS, PERSONAL_EPISODE_04_MATERIALS,
  PERSONAL_EPISODE_05_MATERIALS, PERSONAL_EPISODE_06_MATERIALS,
  PERSONAL_EPISODE_07_MATERIALS, PERSONAL_EPISODE_08_MATERIALS,
];

/** Each uploaded teaching entry keeps its own identity and media, including repeated movements. */
export const PERSONAL_COURSE_MATERIALS = EPISODES.flat();

const COURSE_EPISODE: Record<string, number> = {
  'personal-stretch': 0, 'personal-back': 1, 'personal-arms-1': 2,
  'personal-chest': 3, 'personal-shoulders': 4, 'personal-legs': 5,
  'personal-abs': 6, 'personal-arms-2': 7,
};

export function withPersonalCourseMaterials(course: ICourse): ICourse {
  const index = COURSE_EPISODE[course.id];
  if (course.system !== 'personal' || index === undefined) return course;
  const entries = EPISODES[index];
  // Uploaded numbered order is authoritative. Warmup entries are the leading block in this manifest.
  const firstMain = entries.findIndex(exercise => !exercise.isWarmup);
  const warmupCount = firstMain < 0 ? entries.length : firstMain;
  return {
    ...course,
    days: course.days.map(day => ({
      ...day,
      warmupIds: entries.slice(0, warmupCount).map(exercise => exercise.id),
      mainIds: entries.slice(warmupCount).map(exercise => exercise.id),
      stretchIds: [],
    })),
  };
}
